export enum E_EstadoCausa{
    Asignada = 1,
    AccionRealizada = 2,
    Rechazada = 3,
    Cerrado = 4,
    CerradoObservacion = 5,
    EnProcesoAsignacion = 6
}